import h from "../core/createElement"
import Btn from "./btn";

export default function FileLineCard({ data: { name, size, type, id }, removeClick }) {
    return (
        <article class="card">
            <div class="top">
                <span class="title">{name}</span>
                <Btn color="red" icon="assets/image/backspace.svg" onClick={() => removeClick && removeClick({ name, size, type, id })} />
            </div>
        </article>
    );
};